module.exports = __webpack_public_path__ + "static/media/btn-arrow-black-o.05f7459a.svg";